/**
 * @generated SignedSource<<d5db6b8adafb4b751727a0742b7b27d9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type CommentDisplayFragment$data = {
  readonly author: {
    readonly id: string;
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  };
  readonly content: string;
  readonly createdAt: DateTime;
  readonly edited: boolean;
  readonly id: string;
  readonly parent: {
    readonly id: string;
  } | null | undefined;
  readonly topic: {
    readonly forum: {
      readonly owner: {
        readonly id: string;
      };
    };
  };
  readonly viewerCanDelete: boolean;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CommentDeleteFragment" | "VoteDisplayFragment">;
  readonly " $fragmentType": "CommentDisplayFragment";
};
export type CommentDisplayFragment$key = {
  readonly " $data"?: CommentDisplayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentDisplayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentDisplayFragment",
  "selections": [
    {
      "alias": "viewerCanDelete",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "DELETE_COMMENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
    },
    {
      "alias": "viewerCanUpdate",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_COMMENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "edited",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Forum",
          "kind": "LinkedField",
          "name": "forum",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v1/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CommentDeleteFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "thumbnail",
              "value": true
            }
          ],
          "kind": "FragmentSpread",
          "name": "EntityProfilePicFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteDisplayFragment"
    }
  ],
  "type": "Comment",
  "abstractKey": null
};
})();

(node as any).hash = "f51a40f7588dd4922d80a73c41df0753";

export default node;
